import { Component, EventEmitter, Input, OnInit, Output, ViewChild, inject } from '@angular/core';
import { UntypedFormBuilder, ValidationErrors, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BaseFormComponent } from '@classes/extends';
import { TypeHeadElement } from '@classes/models';
import {
    FonctionUSR, Organisme, OrganismeService as OrganismesService, Pays, PointageService, Profil, ProfilService,
    RFParam, Sig, Telephone, Utilisateur, UtilService as UtilisateurService
} from '@estel-numerique/galaclick-api';
import { FiltreHelper, GalaclickError, PipesModule } from '@estel-numerique/galaclick-core';
import { Constantes } from '@services/util/constantes';

import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CommunesComponent, SelectGala } from '@composants/index';
import { FormValidator } from '@composants/validators';
import { lastValueFrom } from 'rxjs';
import { Periode } from '../models/Periode.model';
import {
    UtilisateurFonctionComponent, UtilisateurFonctionComponentData
} from './../utilisateur-fonction/utilisateurFonction.component';
import { UtilisateurSigComponent, UtilisateurSigComponentData } from './../utilisateur-sig/utilisateurSig.component';
import { DialogGalaComponent } from '../../composants/dialog-gala/dialog-gala.component';
import { AccordionGalaComponent } from '../../composants/accordion-gala/accordion-gala.component';
import { AccordionGalaItemComponent } from '../../composants/accordion-gala/accordion-gala-item/accordion-gala-item.component';
import { AccordionGalaItemHeadComponent } from '../../composants/accordion-gala/accordion-gala-item-head/accordion-gala-item-head.component';
import { AccordionGalaItemBodyComponent } from '../../composants/accordion-gala/accordion-gala-item-body/accordion-gala-item-body.component';
import { SelectGala as SelectGala_1, SelectPhoneGala } from '../../composants/select/select.component';
import { InputGala } from '../../composants/inputs/input.component';
import { UpperCaseDirective, FirstLetterUpDirective } from '../../directive/directive';
import { CommunesComponent as CommunesComponent_1 } from '../../composants/communes.component';
import { DateGalaComponent } from '../../composants/date-gala/date-gala.component';
import { AddButton } from '../../composants/composants';
import { ButtonGalaDeleteComponent } from '../../composants/buttons/btn-gala-delete/btn-gala-delete.component';
import { MatCheckbox } from '@angular/material/checkbox';
import { ButtonGalaEditComponent } from '../../composants/buttons/btn-gala-edit/btn-gala-edit.component';
import { CdkDropList } from '@angular/cdk/drag-drop';
import { MatButton } from '@angular/material/button';
import { DateFormatPipe } from '../../../services/util/pipe';


@Component({
    templateUrl: './utilisateur-detail.component.html',
    imports: [
        DialogGalaComponent, AccordionGalaComponent, AccordionGalaItemComponent, AccordionGalaItemHeadComponent, AccordionGalaItemBodyComponent, FormsModule, ReactiveFormsModule,
        SelectGala_1, InputGala, UpperCaseDirective, FirstLetterUpDirective, CommunesComponent_1, SelectPhoneGala, DateGalaComponent, AddButton, ButtonGalaDeleteComponent, MatCheckbox,
        ButtonGalaEditComponent, CdkDropList, MatButton, PipesModule, DateFormatPipe
    ]
})
export class UtilisateurDetailsComponent extends BaseFormComponent implements OnInit {
    private formBuilder = inject(UntypedFormBuilder);
    private wsProfil = inject(ProfilService);
    private wsOrga = inject(OrganismesService);
    private wsUtil = inject(UtilisateurService);
    private wsPointage = inject(PointageService);
    private dialog = inject(MatDialog);
    private dialogRef = inject<MatDialogRef<UtilisateurDetailsComponent>>(MatDialogRef);
    public data = inject<Utilisateur>(MAT_DIALOG_DATA);

    @ViewChild('communeGala') public communeComp: CommunesComponent;

    @Output() BDDchanges = new EventEmitter<{ util: Utilisateur }>();
    @Input() public titre: string;
    public listePAYS: Pays[];
    public listeTYPETEL: RFParam[] = [];
    public listeCIVILE: RFParam[] = [];
    public listePROFILS: { value: Profil; label: string }[] = [];
    public listePROFILSAVE: { value: Profil; label: string }[] = [];
    public listeOrgaAutre: Organisme[] = [];
    public listeSIG: Organisme[];
    public listeSIGSAVE: Organisme[];
    public listeTypeUtil: RFParam[] = [];
    public listsHaveChange = false;
    private sigType = "d'un élément SIG";
    private functionType = "d'une fonction";

    public headElementsDroitsAcces: TypeHeadElement[] = [];
    public headElementsSIG: TypeHeadElement[] = [];
    public headElementsFoncitons: TypeHeadElement[] = [];

    protected lgTrad: Record<string, string> = {};        // Traduction formulaire principal
    protected lgTradAcces: Record<string, string> = {};   // Traduction volet Profil
    protected lgTradFct: Record<string, string> = {};
    protected lgTradSIG: Record<string, string> = {};

    protected lgTradFiltre: Record<string, string> = {};
    private booPremierAcces = true;
    //Si on est en mode modif le login de l'utilisateur est sauvegardé
    private loginSaved: string;
    public typeEmployeurEtFonction: Record<number, string>;
    public codeModule: string = Constantes.CodeOption.OFICHIERUSER;
    // Code module/option testé pour vérifier l'accès à cette fonction (si null = OK)

    @ViewChild('selectProfil') public selectProfil: SelectGala;

    @Output() hideDetailUser = new EventEmitter();

    public user: Utilisateur;
    public fonction: FonctionUSR = null;


    constructor() {
        super();
        this.dialogRef.updateSize('1200px');
        this.typeEmployeurEtFonction = {
            0: this.translate.instant("APPUTILISATEUR.SECONDAIRE"),
            1: this.translate.instant("APPUTILISATEUR.PRINCIPAL")
        };
        this.lgTrad = {
            ENR: this.translate.instant('ENR'),
            RET: this.translate.instant('RET'),
            CONSULT: this.translate.instant('CONSULT'),
            MODIF: this.translate.instant('MODIF'),
            CREA: this.translate.instant('CREA'),
            GENEDATAS: this.translate.instant('GENEDATAS'),
            CIVILITY: this.translate.instant('APPUTILISATEUR.CIVILITY'),
            COUNTRY: this.translate.instant('COUNTRY'),
            NAME: this.translate.instant('NAME'),
            SURNAME: this.translate.instant('SURNAME'),
            ORGANISME: this.translate.instant('ORGANISME'),
            ADRESSE: this.translate.instant('ADRESSE'),
            COMPLEMENT: this.translate.instant('COMPLEMENT'),
            MAIL: this.translate.instant('MAIL'),
            DEBUT: this.translate.instant('DEBUT'),
            FIN: this.translate.instant('FIN'),
            BEGINNINGDATE: this.translate.instant('BEGINNINGDATE'),
            ENDDATE: this.translate.instant('ENDDATE'),
            DELPLANNING: this.translate.instant('APPUTILISATEUR.DELPLANNING'),
        };
        this.lgTradAcces = {
            RIGHTS: this.translate.instant('APPUTILISATEUR.ACCESS.RIGHTS'),
            PROFIL: this.translate.instant('APPUTILISATEUR.ACCESS.PROFIL'),
            APPLICATIF: this.translate.instant('APPUTILISATEUR.ACCESS.APPLICATIF'),
            LOGIN: this.translate.instant('APPUTILISATEUR.ACCESS.LOGIN'),
            DELETEPROFIL: this.translate.instant('APPUTILISATEUR.ACCESS.DELETEPROFIL')
        };
        this.lgTradSIG = {
            SIG: this.translate.instant('APPUTILISATEUR.SIG.SIG'),
            SIGCODE: this.translate.instant('APPUTILISATEUR.SIG.SIGCODE'),
            NAME: this.translate.instant('NAME'),
            AGENTCODE: this.translate.instant('APPUTILISATEUR.SIG.AGENTCODE'),
            DEBUT: this.translate.instant('DEBUT'),
            FIN: this.translate.instant('FIN'),
            BEGINNINGDATE: this.translate.instant('BEGINNINGDATE'),
            ENDDATE: this.translate.instant('ENDDATE'),

            CREAAGCL: this.translate.instant('APPUTILISATEUR.SIG.CREAAGCL'),
            MODIFAGCL: this.translate.instant('APPUTILISATEUR.SIG.MODIFAGCL'),

            MODIFSIG: this.translate.instant('APPUTILISATEUR.SIG.MODIFSIG'),
            DELETESIG: this.translate.instant('APPUTILISATEUR.SIG.DELETESIG'),
            ANCIENCODE: this.translate.instant('APPUTILISATEUR.SIG.ANCIENCODE')
        };
        this.lgTradFct = {
            EMPNFCT: this.translate.instant('APPUTILISATEUR.FUNCTION.EMPNFCT'),
            FONCTION: this.translate.instant('APPUTILISATEUR.FUNCTION.FUNCTION'),
            EMPLOYER: this.translate.instant('APPUTILISATEUR.FUNCTION.EMPLOYER'),
            ETP: this.translate.instant('APPUTILISATEUR.FUNCTION.ETP'),
            ETPPOURC: this.translate.instant('APPUTILISATEUR.FUNCTION.ETPPOURC'),
            OCTAGRI: this.translate.instant('APPUTILISATEUR.FUNCTION.OCTAGRI'),
            OCTAGRICODE: this.translate.instant('APPUTILISATEUR.FUNCTION.OCTAGRICODE'),
            ORGANISME: this.translate.instant('ORGANISME'),
            TYPE: this.translate.instant('APPUTILISATEUR.FUNCTION.TYPE'),
            DEBUT: this.translate.instant('DEBUT'),
            FIN: this.translate.instant('FIN'),
            BEGINNINGDATE: this.translate.instant('BEGINNINGDATE'),
            ENDDATE: this.translate.instant('ENDDATE'),
            CREAFCT: this.translate.instant('APPUTILISATEUR.FUNCTION.CREAFCT'),
            MODIFFCT: this.translate.instant('APPUTILISATEUR.FUNCTION.MODIFFCT'),
            DELETEFCT: this.translate.instant('APPUTILISATEUR.FUNCTION.DELETEFCT')
        };
        this.formData = this.formBuilder.group({
            CIVILITE: [null, Validators.required],
            NOM: [null, [Validators.required, Validators.maxLength(50)]],
            PRENOM: [null, [Validators.required, Validators.maxLength(50)]],
            CODEPAYS: ['FR', Validators.required],
            TYPEUTIL: [null, Validators.required],
            LOGIN: [null, Validators.required],
            ADRESSEA: [null],
            ADRESSEB: [null],
            COPOST: [null, [Validators.required]],
            COMMUNE: [null, [Validators.required]],
            CEDEX: [null],
            TYPTEL1: [null, [Validators.required]],
            INDICATIF1: ['+33', Validators.required],
            TEL1: [null, [Validators.required, FormValidator.validTel]],
            TYPTEL2: [null],
            INDICATIF2: ['+33'],
            TEL2: [null],
            MAIL: [null, [
                Validators.required, Validators.email,
                Validators.pattern('^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$')]],
            DDEBUT: [null, [Validators.required, FormValidator.validDate]],
            DFIN: [null, [FormValidator.validDate]],
            ORGAAUTRE: [null],
            DELEGATION: [null],
        }, { validators: [this.util.date.compareDate('DDEBUT', 'DFIN')] });
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.show(this.data).catch(e => this.util.fErreur(e));
    }

    async chargeListe() {
        await Promise.all([
            lastValueFrom(this.wsCacheLow.getCivilites()),
            lastValueFrom(this.wsCacheLow.getTyptel()),
            lastValueFrom(this.wsProfil.getProfilListe()),
            lastValueFrom(this.wsCacheLow.getPays()),
            lastValueFrom(this.wsOrga.getPartenaires()),
            lastValueFrom(this.wsOrga.getLaiteriesGala()),
            lastValueFrom(this.wsCacheLow.getTypeUtilisateurs()),
        ]).then((results) => {
            this.listeCIVILE = results[0];
            this.listeTYPETEL = results[1];
            const profils = results[2];
            this.listePROFILSAVE = profils.map((o: Profil) => ({ value: o, label: o.NOMAPP + ' - ' + o.PROFIL }));
            this.listePROFILS = [...this.listePROFILSAVE];
            this.listePAYS = results[3];
            this.listeOrgaAutre = results[4];
            results[5].forEach((o: Organisme) => {
                this.listeOrgaAutre.push(o);
            });
            this.listeTypeUtil = results[6];
        }).catch((error) => { throw error; });
    }

    /**
     * Affiche la fenêtre contenant les détails de l'utilisateur,
     * met à jour les validateurs et rempli les champs si un organisme est donné
     */
    private async show(user?: Utilisateur) {
        this.sessionUser = this.getUserSession();
        this.util.showLoader();
        try {
            if (this.booPremierAcces) {
                await this.chargeListe();
                this.booPremierAcces = false;
            }
            //this.util.resetFormData(this.formSIG);

            //Réinitialisation des valeurs utilisées dans la modale
            this.user = user;
            this.listeSIGSAVE = await lastValueFrom(
                this.wsOrga.getOrganimeChildren(this.sessionUser.ORGAOC.IDORGA, true));
            this.listeSIG = Object.assign([], this.listeSIGSAVE);

            if (this.user.USRID != null) {
                this.booEdition = true;
                this.user = await lastValueFrom(this.wsUtil.getUtil(this.user.USRID));
                this.listePROFILS = Object.assign([], this.listePROFILSAVE);
                if (this.user.PROFILS != null) {
                    this.user.PROFILS = this.user.PROFILS.sort((one: Profil, two: Profil) => (
                        ((one.NOMAPP + one.PROFIL).localeCompare(two.NOMAPP + two.PROFIL) > 0) ? 1 : -1
                    ));

                    if (this.user.PROFILS.length != 0) {
                        this.user.PROFILS.forEach((profil: Profil) => {
                            this.listePROFILS = this.listePROFILS.filter((o) => {
                                if (o.value.IDAPPLICATIF != profil.IDAPPLICATIF) {
                                    return o;
                                }
                            });
                        });
                    }
                    this.listePROFILS = Object.assign([], this.listePROFILS);
                }

                this.formData.reset(this.user);
                if (this.communeComp != null) {
                    this.communeComp.initCommuneCopost(this.user);
                }
                this.formData.get('CIVILITE').setValue(this.user.CIVILITE.ID);
                this.formData.get('TYPTEL1').setValue(this.user.TELA.TYPTEL);
                this.formData.get('TYPTEL2').setValue(this.user.TELB.TYPTEL);
                this.formData.get('TEL1').setValue(this.util.telephone.fTelAddSep(this.user.TELA));
                this.formData.get('TEL2').setValue(this.util.telephone.fTelAddSep(this.user.TELB));
                this.formData.get('INDICATIF1').setValue(this.user.TELA.INDICATIF);
                this.formData.get('INDICATIF2').setValue(this.user.TELB.INDICATIF);
                this.formData.get('DDEBUT').setValue(this.user.DDEBUT);
                this.formData.get('DFIN').setValue(this.user.DFIN);
                this.formData.get('DELEGATION').setValue((this.user.DELEGATION == 1) ? true : false);

                //save du login
                this.loginSaved = this.user.LOGIN;

                if (this.user.LISTESIG != null) {
                    this.user.LISTESIG = this.user.LISTESIG.sort((one: Sig, two: Sig) => (
                        (one.NOMSIG.localeCompare(two.NOMSIG) > 0) ? 1 : -1
                    ));

                    //Affectation du code de l'agent
                    /*if (this.user.LISTESIG.length > 0) {
                        this.formSIG.get('COAGCL').setValue(this.user.LISTESIG[0].COAGCL);
                    }*/
                }

                //ORGA AUTRE
                if (this.user.TYPEUTIL.CODE == 'AUT' && this.user.ORGAAUTRE != null) {
                    this.formData.get('ORGAAUTRE').setValue(this.listeOrgaAutre.find((o: Organisme) => {
                        return this.user.ORGAAUTRE.IDORGA == o.IDORGA;
                    }));
                }
                this.sortFonctions();

                this.formData.markAsUntouched();
                this.formData.markAsPristine();
            } else {
                this.booEdition = false;
            }
            this.initFormValues();
        } catch (e) {
            this.util.fErreur(e);
        }
        this.util.hideLoader();
    }

    /**
     * Si les données du formulaire sont valident, ajoute l'utilisateur à la liste des utilisateurs
     */
    async save() {
        this.util.showLoader();
        try {
            if (!this.booEdition) {
                await this.isLOGINUsed();
            }

            this.validationFormulaire();
            //Booléen de confirmation de validation du formulaire
            // (utiulisé par exemple pour confirmer validation des etp non a 100 %)
            let boConfirmForm = true;
            let boConfirmDate = false;

            const periode = this.verifierDates();
            if (periode.periode && periode.periode.length > 0) {
                const type = periode.source === 'SIG' ? this.sigType : this.functionType;
                const periodeMsg = periode.periode.length === 1
                    ? periode.periode[0].formatEuropeen()
                    : periode.periode.map((p: Periode) => p.formatEuropeen()).join(', ');
                const tradKey = periode.periode.length === 1
                    ? 'APPUTILISATEUR.DEPPERUTIL.SIMPLE'
                    : 'APPUTILISATEUR.DEPPERUTIL.PLURIELLE';
                this.util.showToastError(
                    this.translate.instant(tradKey)
                        .replace('{periode}', periodeMsg)
                        .replace('{type}', type)
                );
                this.util.hideLoader();
                return;
            }

            // Dans tous les cas il a obligatoirmeent un profil
            this.validationMinLength(this.user.PROFILS, 1,
                this.translate.instant('LISTDROITSMINLENGTH'), 'droitsAccesMinLength');

            // Si c'est un AGENT (SIG ou NON) il a obligatoirement une fonction
            if (this.util.isAGENT(this.user) || this.util.isSALARIE(this.user)) {
                if (this.validationMinLength(this.user.FONCTIONS, 1,
                    this.translate.instant('LISTFCTMINLENGTH'), 'fonctionsMinLength')) {
                    //retourne true si annula la validation car etp <= 100
                    boConfirmForm = await this.validationETP(this.user.FONCTIONS);
                }

                this.user.TYPEUTIL.CODE = (this.user.LISTESIG == null || this.user.LISTESIG.length == 0) ?
                    FiltreHelper.TypeUtilisateur.SALARIE : FiltreHelper.TypeUtilisateur.AGENT;

                // Controle si dans les fonctions j'ai bien une principale
                if (this.user.FONCTIONS != null) {
                    for (const donnee of this.user.FONCTIONS) {
                        if (donnee.PRINCIPAL == 1) {
                            boConfirmDate = true;
                        }
                    }
                }
                if (!boConfirmDate && boConfirmForm) {
                    this.util.showToastError(this.translate.instant('APPUTILISATEUR.FUNCTION.NOFUNCTION'));
                }
            }

            if (this.formData.valid && boConfirmForm && boConfirmDate) {

                //On map le form sur la valeur que l'on va renvoyé au webservice
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                const oData: Utilisateur & {
                    TEL1: string;
                    TEL2: string;
                    TYPTEL1: number;
                    TYPTEL2: number;
                    INDICATIF1: string;
                    INDICATIF2: string;
                } = Object.assign({} as Utilisateur, this.user, this.formData.value);

                //On recrée les objets qui ne sont plus complet
                oData.NOM = this.util.upperCase(oData.NOM);
                oData.PRENOM = this.util.upFirstLetter(oData.PRENOM);
                //TEL
                let tel: Telephone = { TYPTEL: null, INDICATIF: null, NUMERO: null };
                tel.NUMERO = this.util.telephone.fTelStrip(oData.TEL1);
                tel.TYPTEL = oData.TYPTEL1;
                tel.INDICATIF = oData.INDICATIF1;
                oData.TELA = tel;
                tel = { TYPTEL: null, INDICATIF: null, NUMERO: null };
                tel.NUMERO = this.util.telephone.fTelStrip(oData.TEL2);
                tel.TYPTEL = oData.TYPTEL2;
                tel.INDICATIF = oData.INDICATIF2;
                oData.TELB = tel;
                delete oData.TYPTEL1;
                delete oData.TYPTEL2;
                delete oData.INDICATIF1;
                delete oData.INDICATIF2;
                delete oData.TEL1;
                delete oData.TEL2;

                //COMMUNE
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                oData.COMMUNE = (oData.COMMUNE as any).value as string;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                oData.COPOST = (oData.COPOST as any).value as string;
                //CIVILITE
                const param: RFParam = { ID: oData.CIVILITE as number, LIB: null, CODE: null };
                oData.CIVILITE = param;

                //ORGANISME
                //let orga: Organisme = { IDORGA: oData.ORGANISME }
                //oData.ORGANISME = orga
                oData.CEDEX = this.util.setCheckboxValue(oData.CEDEX == 1 ? true : false);

                oData.DDEBUT = String(this.formData.get('DDEBUT').value);
                oData.DFIN = this.formData.get('DFIN').value as string;
                oData.LISTESIG = [];
                oData.DELEGATION = (oData.DELEGATION) ? 1 : 0;
                oData.TYPEUTIL = this.listeTypeUtil.find((rfparam: RFParam) => {
                    return oData.TYPEUTIL.CODE == rfparam.CODE;
                });
                if (this.user.LISTESIG != null) {
                    await this.checkDFIN();

                    //On instancie chaque SIG comme ca pour éviter de modifier les sig de l'utilisateur affiché
                    this.user.LISTESIG.forEach((sig: Sig) => {
                        //on verifie au passage qu'aucun sig n'est inférieur a la ddebut de lutilisateur
                        if (sig.DDEBUT < oData.DDEBUT) {
                            throw new GalaclickError(this.translate.instant('APPUTILISATEUR.ERRORDATESIG'));
                        }

                        const SIGTMP: Sig = {
                            IDORGA: sig.IDORGA,
                            NOMSIG: sig.NOMSIG,
                            COSIG: sig.COSIG,
                            COAGCL: sig.COAGCL,
                            DDEBUT: sig.DDEBUT,
                            DFIN: sig.DFIN,
                            ANCIENCODE: sig.ANCIENCODE
                        };
                        oData.LISTESIG.push(SIGTMP);

                    });
                }
                if (!this.verifierFonctionAndDfin(oData)) {
                    this.util.fErreur(this.translate.instant('APPUTILISATEUR.FUNCTION.NODATEFINUTIL'));
                    return;
                }
                oData.FONCTIONS = this.user.FONCTIONS;
                if (this.booEdition) {
                    await lastValueFrom(this.wsUtil.putUtil(this.user.USRID, oData));
                    this.util.showToastSuccess(this.translate.instant('APPUTILISATEUR.MODIFSUCCESS'));
                    this.hideModal(true);
                } else {
                    await lastValueFrom(this.wsUtil.postUtil(oData));
                    this.util.showToastSuccess(this.translate.instant('APPUTILISATEUR.CREASUCCESS'));
                    this.hideModal(true);
                }
                // on ne cache pas le loader
                this.BDDchanges.emit({ util: oData });
                this.listsHaveChange = false;
            } else {
                this.util.hideLoader();
            }
        } catch (e) {
            this.util.fErreur(e);
        } finally {
            this.util.hideLoader();
        }
    }

    public addProfil(profil?: Profil) {
        try {
            if (profil != null) {
                this.selectProfil.selectedItem = profil;
            }
            if (this.selectProfil.selectedItem != null) {
                if (this.user.PROFILS == null) {
                    this.user.PROFILS = [];
                }
                //on ajoute a l'utilisateur le profil
                this.user.PROFILS.push(this.selectProfil.selectedItem as Profil);

                //on filtre la liste des profils pour ne plus avoir de profil pour le meme applciatif
                this.listePROFILS = this.listePROFILS.filter((o) => {
                    if (o.value.IDAPPLICATIF != (this.selectProfil.selectedItem as Profil).IDAPPLICATIF) {
                        return true;
                    }
                });
                this.selectProfil.writeValue(null);
                this.listsHaveChange = true;
            } else {
                this.util.showToastError(this.translate.instant('APPUTILISATEUR.NOPROFSELECTED'));
            }
        } catch (e) {
            this.util.fErreur(e);
        }
    }

    public deleteProfil(prof: Profil) {
        this.util.fConfirm(this.translate.instant('SUPPRCONFIRM', { libelle: this.translate.instant('APPUTILISATEUR.PROFILSUPPR') + prof.NOMAPP })
            , () => {
                this.listsHaveChange = true;
                this.user.PROFILS.splice(this.user.PROFILS.findIndex((o: Profil) => {
                    return prof.IDPROFIL == o.IDPROFIL;
                }), 1);

                this.listePROFILSAVE.filter((o) => {
                    if (o.value.IDAPPLICATIF == prof.IDAPPLICATIF) {
                        this.listePROFILS.push(o);
                    }
                });

                this.listePROFILS = Object.assign([], this.listePROFILS);
            });
    }

    public filtreProfilByOrga(idOrga: number) {
        if (idOrga == null) {
            this.listePROFILS = this.listePROFILSAVE;
        } else {
            this.listePROFILS = this.listePROFILSAVE.filter((p) => {
                return p.value.IDOC == idOrga;
            });
        }
    }

    public hideModal(force?: boolean) {
        if (!force && (!this.formData.untouched || this.listsHaveChange)) {
            this.util.fConfirm(this.translate.instant('QUITNOSAVE'), () => { this.hideModal(true); }, this.translate.instant('MODIFDONE'));
        } else {
            this.dialogRef.close();
            this.listePROFILS = Object.assign([], this.listePROFILSAVE);
            this.listsHaveChange = false;
        }
        this.hideDetailUser.emit();
    }

    public initFormValues() {
        if (this.formData.get('TYPTEL1').value == null) {
            this.formData.get('TYPTEL1').setValue(this.util.getParamByCode(this.listeTYPETEL, 'PPR').ID);
        }
        if (this.formData.get('TYPTEL2').value == null) {
            this.formData.get('TYPTEL2').setValue(this.util.getParamByCode(this.listeTYPETEL, 'PPR').ID);
        }
        this.formData.get('TYPEUTIL').setValue(this.user.TYPEUTIL);

        //Orga autre
        this.formData.get('ORGAAUTRE').setValidators([FormValidator.verifRequired(this.user.TYPEUTIL.CODE == 'AUT')]);
        const orga: Organisme = this.formData.get('ORGAAUTRE').value as Organisme;
        if (orga && orga.IDORGA == null) {
            this.formData.get('ORGAAUTRE').setValue(null);
        }
    }

    public async isLOGINUsed(displayToast?: boolean) {
        try {
            let login = this.formData.get('LOGIN').value as string;
            if (login != null && login != this.loginSaved) {
                login = login.toUpperCase();
                if (login.trim() != '') {
                    if (await lastValueFrom(this.wsUtil.checkIfLoginIsUsed(login)) == true) {
                        this.formData.get('LOGIN').setErrors({ 'LOGINUsed': true });
                        if (displayToast && displayToast == true) {
                            this.util.showToastError(this.translate.instant('FORMERROR.MSGSTART') + this.translate.instant('FORMERROR.LOGIN')
                                + this.translate.instant('FORMERROR.LOGINUSED'));
                        }
                        return true;
                    } else {
                        this.formData.get('LOGIN').setErrors(null);
                        if (displayToast && displayToast == true) {
                            this.util.showToastSuccess(this.translate.instant('FORMERROR.MSGSTART') + this.translate.instant('FORMERROR.LOGIN')
                                + this.translate.instant('FORMERROR.VALID'));
                        }
                        return false;
                    }
                }
            }
        } catch (e) {
            this.util.fErreur(e);
        }
        return false;
    }

    public showModalFonction(fonction?: FonctionUSR) {
        const dial = this.dialog.open(UtilisateurFonctionComponent, {
            data: {
                user: this.user,
                fonction: fonction
            } as UtilisateurFonctionComponentData
        });
        dial.componentInstance.modification.subscribe((listeFonctions) => {
            this.user.FONCTIONS = [...listeFonctions];
        });
    }


    public showModalSIG(oSig?: Sig) {
        const tempUser = this.user;
        tempUser.DDEBUT = this.formData.get('DDEBUT').value as string;
        tempUser.DFIN = this.formData.get('DFIN').value as string;
        this.dialog.open(UtilisateurSigComponent, {
            data: {
                sig: oSig,
                user: this.user,
                listeSig: this.listeSIGSAVE
            } as UtilisateurSigComponentData
        });
    }


    public async deleteFonction(fonction: FonctionUSR) {
        const message = this.translate.instant('SUPPRCONFIRM', { libelle: this.translate.instant('APPUTILISATEUR.FONCTIONSUPPR') + '\'' + fonction.FONCTION.FONCTION +
            '\'' + this.translate.instant('APPUTILISATEUR.ORGANISMESUPPR') + '\'' + fonction.ORGANISME.NOM + '\'' +
            ' sur la période : ' + new Periode(fonction.DDEBUT, fonction.DFIN).formatEuropeen() });

        try {
            const confirmed = await this.util.confirmation(message);
            if (confirmed) {
                this.listsHaveChange = true;
                try {
                    await lastValueFrom(this.wsPointage.verifierActivites(
                        this.user.USRID,
                        fonction.DDEBUT,
                        fonction.DDEBUT,
                        true
                    ));
                } catch (e) {
                    throw new Error(this.translate.instant('APPUTILISATEUR.FUNCTION.SUPPRIMP'));
                }
                const i = this.user.FONCTIONS.findIndex((f: FonctionUSR) => f === fonction);
                if (this.user.FONCTIONS[i].PRINCIPAL === 1) {
                    const fctSecondaire = this.user.FONCTIONS.filter((f: FonctionUSR) => f.PRINCIPAL === 0);
                    // Vérifiez que le tableau contient des éléments, pas seulement qu'il existe
                    if (fctSecondaire.length > 0) {
                        let peutSupprimer = true;
                        for (const fct of fctSecondaire) {
                            if (new Periode(fct.DDEBUT, fct.DFIN).estContenuDans(new Periode(fonction.DDEBUT, fonction.DFIN))) {
                                this.util.showToastError(this.translate.instant('APPUTILISATEUR.FUNCTION.DELIMP'));
                                peutSupprimer = false;
                                break;
                            }
                        }
                        if (peutSupprimer) {
                            this.user.FONCTIONS.splice(i, 1);
                        }
                    } else {
                        // Si pas de fonctions secondaires, on peut supprimer
                        this.user.FONCTIONS.splice(i, 1);
                    }
                } else {
                    this.user.FONCTIONS.splice(i, 1);
                }
            }
        } catch (e) {
            this.util.fErreur(e);
        }
    }

    public async deleteSIG(SIG: Sig) {
        const message = this.translate.instant('SUPPRCONFIRM', { libelle: this.translate.instant('APPUTILISATEUR.AGENTSIGSUPPR') + ' ' + SIG.COSIG + ' - ' + SIG.NOMSIG });

        try {
            const booOK = await this.util.confirmation(message);
            if (booOK) {
                if (this.user.USRID) {
                    try {
                        this.util.showLoader();
                        try {
                            await lastValueFrom(this.wsUtil.checkSuppSig(this.user.USRID, 1, SIG));
                            this.listsHaveChange = true;
                            const i = this.user.LISTESIG.findIndex((s: Sig) => s.IDORGA == SIG.IDORGA);
                            this.listeSIG.push(this.listeSIGSAVE.find((sig: Sig) => sig.IDORGA == SIG.IDORGA));
                            this.setListSIG();
                            this.user.LISTESIG.splice(i, 1);
                        } catch (e) {
                            this.util.fErreur(e);
                        } finally {
                            this.util.hideLoader();
                        }
                    } catch (e) {
                        this.util.fErreur(e);
                    }
                } else {
                    const index = this.user.LISTESIG.findIndex((s: Sig) => s === SIG);
                    if (index !== -1) {
                        this.user.LISTESIG.splice(index, 1);
                    }
                }
            }
        }
        catch (e) {
            this.util.fErreur(e);
        }
    }

    public setListSIG(list: Sig[] = this.listeSIG) {
        this.listeSIG = Object.assign([], list);
    }

    public validationMinLength(list: unknown[], min: number, msgErreur: string = this.translate.instant('NOTENOUGHTELT'), formError = 'listMinLength') {
        let oldErrors: ValidationErrors = this.formData.errors;
        if (oldErrors == null) {
            oldErrors = {};
        }

        try {
            if (list.length < min) {
                this.util.showToastError(msgErreur);
                oldErrors[formError] = true;
                this.formData.setErrors(oldErrors);
                return false;
            } else if (oldErrors[formError] == true) {
                delete oldErrors[formError];
            }

            if (Object.keys(oldErrors).length == 0) {
                oldErrors = null;
            }
            this.formData.setErrors(oldErrors);
            return true;
        } catch (e) {
            this.util.showToastError(msgErreur);
            oldErrors[formError] = true;
            this.formData.setErrors(oldErrors);
            return false;
        }
    }

    public async validationETP(list: FonctionUSR[]) {
        let total = 0;

        // on recupere la date la plus basse parmis toutes les fonctions
        let dDate: string = null;
        list.forEach((usr) => {
            if (dDate == null) {
                dDate = usr.DDEBUT;
            } else if (dDate > usr.DDEBUT) {
                dDate = usr.DDEBUT;
            }
        });

        // Calcul du total du temps de travail

        list.forEach((usr) => {
            // On verifie que la fonction est comprise AJD
            if (this.util.date.compareTodayDate(usr.DDEBUT, usr.DFIN, true, dDate)) {
                total += Number(usr.ETP);
            }
        });

        // Test du total
        if (total > 100) {
            // On enleve le loader pour afficher la fenetre de ocnfirmation correctement
            this.util.hideLoader();
            const boETP = await this.confirmETP(1);
            // on remet le loader
            this.util.showLoader();
            // Si il a cliqué sur annulé on return false pour ne pas valider le formulaire
            if (!boETP) {
                return false;
            }
        }
        return true;
    }

    /**
     * Message de confirmation si l'etp est inférieur ou supérieur
     * @param param correspond au message  à affiché si inferieur ou supérieur
        * 1 = message ETP > 100
        * 2 = message ETP < 100
     */
    private async confirmETP(param: number) {
        const msg = (param == 1) ? this.translate.instant('APPUTILISATEUR.ETPLIMIT>') : this.translate.instant('APPUTILISATEUR.ETPLIMIT<');
        return await this.util.confirmation(msg, this.translate.instant('ATTENTION'));
    }



    public onChangePays(valueSelected: string) {
        try {
            if (valueSelected != null) {
                if (valueSelected.trim() != '') {
                    const indicatif = this.listePAYS.find((pays) => pays.COPAIP == valueSelected).INDICATIF;
                    this.formData.get('INDICATIF1').setValue(indicatif);
                    this.formData.get('INDICATIF2').setValue(indicatif);
                }
            } else {
                this.formData.get('INDICATIF1').setValue(null);
                this.formData.get('INDICATIF2').setValue(null);
            }
        } catch (e) {
            this.util.fErreur(e);
        }
    }


    /**
     *  Si on a une date de fin on mets toutes ses fonctions et affectations SIG avec une date de fin
     */
    async checkDFIN() {
        const form = this.formData.get('DFIN');
        const dfin: string = form.value as string;
        if (dfin != null && form.valid) {
            const dfinBDD = dfin;
            let boChange = false;
            let error = null;

            const listeSIGSAVE: Sig[] = [];
            this.user.LISTESIG.forEach((sig) => {
                listeSIGSAVE.push(Object.assign({}, sig));
            });

            // on met la dfin sur les SIG
            this.user.LISTESIG.forEach((sig) => {

                if (sig.DFIN != null && sig.DFIN !== dfinBDD) {
                    // check si la dfin existante pour la fonction est sup a la dfin saisie
                    if (sig.DFIN > dfinBDD) {
                        sig.DFIN = dfinBDD;
                        boChange = true;
                    }
                } else {
                    sig.DFIN = dfinBDD;
                    boChange = true;
                }
            });

            // verifie qu'il peut ajouter une date de fin
            error = await this.checkDFINSIG();

            if (error == null) {
                // commence par les fonctions
                this.user.FONCTIONS.forEach((fonction) => {
                    if (fonction.DFIN != null) {
                        // check si la dfin existante pour la fonction est sup a la dfin saisie
                        if (fonction.DFIN > dfinBDD) {
                            fonction.DFIN = dfinBDD;
                            boChange = true;
                        }
                    } else {
                        fonction.DFIN = dfinBDD;
                        boChange = true;
                    }
                });
            }

            // On informe du changement de date
            if (boChange && error == null) {
                this.util.showToastInfo(this.translate.instant('APPUTILISATEUR.NEWDFIN'));
            } else if (error != null) {
                this.user.LISTESIG = listeSIGSAVE;
                throw error;
            }
        }
    }

    public async checkDFINSIG(): Promise<null> {
        // on enchaine avec les SIGS
        for (const sig of this.user.LISTESIG) {
            try {
                if (this.booEdition && sig.DFIN != null) {
                    await lastValueFrom(this.wsUtil.checkSuppSig(this.user.USRID, 0, sig));
                }
            } catch (e) {
                console.error(e);
                throw e;
            }
        }
        return null;
    }

    private sortFonctions() {
        this.user.FONCTIONS.sort((a, b) => {
            // Gérer les cas où DFIN est null pour ordonner ceux qui sont encore actifs en premier
            if (a.DFIN === null && b.DFIN !== null) return -1;
            if (a.DFIN !== null && b.DFIN === null) return 1;

            // Si les deux DFIN sont null ou égaux, comparer par PRINCIPAL
            if (a.DFIN === b.DFIN) {
                return Number(b.PRINCIPAL) - Number(a.PRINCIPAL);
            }

            // Comparer les dates DFIN si elles existent toutes les deux
            const dateA = new Date(a.DFIN).getTime();
            const dateB = new Date(b.DFIN).getTime();
            return dateB - dateA;
        });

    }

    /**
    * Vérifie si la période saisie dans le formulaire est valide par rapport aux périodes
    * des SIG et des FONCTIONS de l'utilisateur.
    * @returns Un objet contenant la période non valide et sa source, ou null si tout est valide
    */
    private verifierDates(): { periode: Periode[] | null, source: 'SIG' | 'FONCTION' | null } {
        const periodeFormulaire = this.extrairePeriodeDuFormulaire();
        let resultatSIG: { periode: Periode[] | null, source: 'SIG' | 'FONCTION' | null } | null = null;
        let resultatFonction: { periode: Periode[] | null, source: 'SIG' | 'FONCTION' | null } | null = null;
        // Vérification des périodes SIG
        if (this.user.LISTESIG) {
            resultatSIG = this.verifierPeriodesCollection(
                this.user.LISTESIG,
                periodeFormulaire,
                'SIG'
            );
        }

        if (resultatSIG) return resultatSIG;

        // Vérification des périodes FONCTIONS
        if (resultatFonction) {
            resultatFonction = this.verifierPeriodesCollection(
                this.user.FONCTIONS,
                periodeFormulaire,
                'FONCTION'
            );
        }

        if (resultatFonction) return resultatFonction;

        return { periode: null, source: null };
    }

    /**
     * Extrait la période saisie dans le formulaire
     */
    private extrairePeriodeDuFormulaire(): Periode {
        const dateDebut = this.formData.get('DDEBUT').value as string;
        const dateFin = this.formData.get('DFIN').value as string;
        return new Periode(dateDebut, dateFin);
    }

    /**
     * Vérifie si une période du formulaire est valide par rapport à une collection d'éléments
     * @param collection Collection d'éléments (SIG ou FONCTION) à vérifier
     * @param periodeFormulaire Période saisie dans le formulaire
     * @param source Type de la source ('SIG' ou 'FONCTION')
     * @returns Résultat de la vérification ou null si tout est valide
     */
    private verifierPeriodesCollection<T extends { DDEBUT?: string, DFIN?: string }>(
        collection: T[],
        periodeFormulaire: Periode,
        source: 'SIG' | 'FONCTION'
    ): { periode: Periode[] | null, source: 'SIG' | 'FONCTION' | null } | null {
        for (const element of collection) {
            if (!element.DDEBUT) continue;
            const elementPeriode = new Periode(element.DDEBUT, element.DFIN);
            if (!elementPeriode.estContenuDans(periodeFormulaire)) {
                return {
                    periode: elementPeriode.soustraire(periodeFormulaire),
                    source: source
                };
            }
        }
        return null;
    }

    private verifierFonctionAndDfin(data: Utilisateur & {
        TEL1: string;
        TEL2: string;
        TYPTEL1: number;
        TYPTEL2: number;
        INDICATIF1: string;
        INDICATIF2: string;
    }): boolean {

        // On récupère les fonctions principales
        const fonctionsPrincipale = this.user.FONCTIONS.filter((f: FonctionUSR) => {
            return f.PRINCIPAL == 1;
        });

        // Si l'utilisateur a une date de fin, on n'a pas besoin de vérifier ses fonctions
        if (data.DFIN != null) {
            this.user.FONCTIONS.forEach((f: FonctionUSR) => {
                if (f.DFIN == null || f.DFIN === '') {
                    f.DFIN = data.DFIN;
                }
            });
            return true;
        }

        return fonctionsPrincipale
            .some(fonction => fonction.DFIN == null || fonction.DFIN === '');
    }

}
